import React from 'react';
import IncludedApps from './IncludedApps/IncludedApps';
import styles from './WelcomePanel.module.css';

const CARDS = [
  { id: 'projects', title: 'Projects', body: 'Create a project or continue working on one you have saved.' },
  { id: 'publishing', title: 'Publishing', body: 'Release your applications and open applications included with your workspace.' },
  { id: 'visual-editor', title: 'Visual Editor', body: 'Build an interface by adding and arranging components.' },
  { id: 'json-editor', title: 'JSON Editor', body: 'View and edit the definition of your current project.' },
  { id: 'preview', title: 'Preview', body: 'Try your current project before publishing it.' },
];
export default function WelcomePanel({ onNavigate }: {onNavigate: (id: string) => void}): React.ReactElement {
  return <div className={styles.panel}>
    <h1 className={styles.title}>Welcome to Conductor</h1>
    <p className={styles.subtitle}>Build applications for your workflows, publish them for your users, and open the tools installed for your workspace.</p>
    <div className={styles.cardGrid}>{CARDS.map(card => <button type="button" key={card.id} className={styles.card} onClick={() => onNavigate(card.id)}>
      <span className={styles.cardTitle}>{card.title}</span><span className={styles.cardBody}>{card.body}</span>
    </button>)}</div>
    <IncludedApps showConfiguration />
  </div>;
}
